export default __webpack_public_path__ + "static/media/flattenthecurve.png.webp";